import { ChecklistLead } from '@/types/leads.types';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { toast } from 'sonner';

interface ExportButtonProps {
  leads: ChecklistLead[];
}

const practiceTypeLabels: Record<string, string> = {
  hausarzt: 'Hausarzt',
  zahnarzt: 'Zahnarzt',
  facharzt: 'Facharzt',
  mvz: 'MVZ',
  klinik: 'Klinik',
};

const statusLabels: Record<string, string> = {
  new: 'Neu',
  contacted: 'Kontaktiert',
  qualified: 'Qualifiziert',
  converted: 'Konvertiert',
  lost: 'Verloren',
};

export const ExportButton = ({ leads }: ExportButtonProps) => {
  const exportToCSV = () => {
    const headers = ['Name', 'E-Mail', 'Praxistyp', 'Telefon', 'Beratungswunsch', 'Status', 'Notizen', 'Letzter Kontakt', 'Download-Datum'];
    
    const rows = leads.map(lead => [
      lead.name,
      lead.email,
      practiceTypeLabels[lead.practice_type] || lead.practice_type,
      lead.phone || '',
      lead.wants_consultation ? 'Ja' : 'Nein',
      statusLabels[lead.status] || lead.status,
      lead.notes || '',
      lead.last_contacted_at ? new Date(lead.last_contacted_at).toLocaleDateString('de-DE') : '',
      new Date(lead.created_at).toLocaleDateString('de-DE'),
    ]);

    const csvContent = [
      headers.join(';'),
      ...rows.map(row => row.join(';')),
    ].join('\n');

    // Add BOM for proper UTF-8 encoding in Excel
    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `checklist-leads-${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast.success(`${leads.length} Leads erfolgreich exportiert`);
  };

  return (
    <Button onClick={exportToCSV} variant="outline" className="gap-2">
      <Download className="w-4 h-4" />
      CSV exportieren ({leads.length} Einträge)
    </Button>
  );
};
